module.exports = __webpack_public_path__ + "static/media/10-11.1837659e.mp3";